<template>
  <el-form-item :label="fieldDetail.options.label || fieldDetail.name" :prop="fieldDetail.options.model">
    <component
      :is="fieldDetail.components"
      v-model="value"
      :field-detail="fieldDetail"
      v-bind="fieldDetail.options"
      class="template-field"
      :disable="disable"
      v-model:pageObj="pageValue"
    />
  </el-form-item>
</template>

<script>
import TemplateFieldRenderList from '@/components/TemplateMaking/TemplateField/TemplateFieldRenderList'
export default {
  name: 'TemplateFieldRender',
  emits: ['update:modelValue', 'update:pageParentObj'],
  components: {
    ...TemplateFieldRenderList
  },
  props: {
    fieldDetail: {
      type: Object,
      require: true
    },
    disable: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [Array, Number, String, Object]
    },
    pageParentObj: {
      type: Object,
    }
  },
  computed: {
    value: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    },
    pageValue: {
      get () {
        return this.pageParentObj
      },
      set (val) {
        this.$emit('update:pageParentObj', val)
      }
    }
  }
}
</script>

<style scoped>
  /*.template-field ::v-deep(.el-input__inner, .el-textarea__inner) {*/
  /*  width: 80%;*/
  /*}*/
</style>
